export default __webpack_public_path__ + "static/media/AdobeStock_112270797.9dcab244.jpeg";